import React, { useContext } from "react";
import {
  Box,
  styled,
  useTheme,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import { MandatorContext } from "@rentablo/theming";
import { SidebarInfo } from "@components";
import { Logo } from "@rentablo/components";
import { goToDashboard } from "@helpers/mainAppUrls";
import CloseIcon from "@icons/myicons/burger-close.svg?react";

const SidebarContainer = styled(Box)(({ theme }) => ({
  height: "100%",
  width: "300px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  flexShrink: 0,
  background: theme.palette.background.subtle,
  padding: theme.spacing(3, 6, 5),

  [theme.breakpoints.down("md")]: {
    paddingTop: theme.spacing(2),
  },
}));

export const RecommenderSidebar = ({ onClose }: { onClose?: () => void }) => {
  const theme = useTheme();
  const isMoreMd = useMediaQuery(theme.breakpoints.up("md"));
  const { isOnvista } = useContext(MandatorContext);

  return (
    <SidebarContainer>
      <Box>
        {isMoreMd ? (
          <Box mt={isOnvista ? 3 : 1} mb={30}>
            <Logo onClick={goToDashboard} />
          </Box>
        ) : (
          <Box display="flex" justifyContent="end" alignItems="center" mb={10}>
            <Box mr={isOnvista ? 6 : 5} minWidth={0} width="100%">
              <Logo onClick={goToDashboard} />
            </Box>
            <Box display="flex" justifyContent="flex-end" mr={-4}>
              <IconButton
                onClick={onClose}
                sx={{
                  width: "48px",
                  height: "48px",
                  padding: (theme) => theme.spacing(1),
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        )}
      </Box>
      <SidebarInfo />
    </SidebarContainer>
  );
};
